import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { siteInfo } from "@/mocks/site";

export default function MethodSection() {
  return (
    <section className="border-y border-background-200 bg-foreground-950 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-4">
            <span className="text-xs font-medium tracking-[0.3em] text-accent-400">
              OUR METHOD
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
              我们如何做一次「深挖」
            </h2>
            <p className="mt-5 text-sm leading-7 text-background-300">
              每一个专题都遵循同一套流程：先建立时间线，再标注信源等级，最后交叉比对多方叙述。流程公开，结论才经得起复查。
            </p>
            <div className="mt-8 grid grid-cols-2 gap-5">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label}>
                  <p className="font-heading text-2xl font-bold text-accent-400 md:text-3xl">
                    {stat.value}
                    <span className="ml-1 text-sm font-normal text-background-400">
                      {stat.unit}
                    </span>
                  </p>
                  <p className="mt-1 text-xs text-background-400">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-3">
              {categories.map((category) => (
                <Link
                  key={category.id}
                  to={`/topics?category=${category.id}`}
                  className="group flex flex-col rounded-xl border border-background-800 bg-background-900/30 p-6 transition-colors hover:border-accent-400/60"
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                    <i className={`${category.icon} text-2xl`} />
                  </span>
                  <h3 className="mt-5 font-heading text-lg font-semibold text-background-50">
                    {category.name}
                  </h3>
                  <p className="mt-3 flex-1 text-sm leading-7 text-background-300">
                    {category.desc}
                  </p>
                  <span className="mt-5 flex items-center justify-between text-xs text-background-400">
                    <span>{category.count} 篇归档</span>
                    <i className="ri-arrow-right-line text-accent-400 transition-transform group-hover:translate-x-1" />
                  </span>
                </Link>
              ))}
            </div>

            <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2">
              {siteInfo.principles.slice(0, 2).map((principle) => (
                <div
                  key={principle.title}
                  className="rounded-xl border border-background-800 bg-background-900/30 p-6"
                >
                  <div className="flex items-center gap-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500/15 text-accent-400">
                      <i className={principle.icon} />
                    </span>
                    <h3 className="font-heading text-base font-semibold text-background-50">
                      {principle.title}
                    </h3>
                  </div>
                  <p className="mt-4 text-sm leading-7 text-background-300">{principle.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}